import { render, staticRenderFns } from "./ECommerceProductDetails.vue?vue&type=template&id=d0a2acac&scoped=true&"
import script from "./ECommerceProductDetails.vue?vue&type=script&lang=js&"
export * from "./ECommerceProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceProductDetails.vue?vue&type=style&index=0&id=d0a2acac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a2acac",
  null
  
)

export default component.exports